// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_lx-0";